<template>
  <div class="pa-10">
    <div class="back">
      <v-row no-gutters class="ml-4">
        <v-col cols="12" md="2" sm="2">
          <router-link
            class="mr-2"
            :to="{ name: 'reports' }"
            :style="{ color: link }"
            >/Reportes de usuarios</router-link
          >
        </v-col>

        <v-col cols="12" md="2" sm="2">
          <router-link :to="{ name: 'player-reports' }" :style="{ color: link }"
            >/Reportes</router-link
          >
        </v-col>
        <v-col cols="12" md="8" sm="8"></v-col>
      </v-row>
    </div>
    <br />
    <v-card :color="color" dark elevation="24">
      <v-card-title class="justify-center">
        <p class="font-weight-light title pt-1" aria-label="tabla métricas">
          {{ this.$route.params.name }} {{ this.$route.params.surname }} -
          Reporte de Sesiones
        </p>
      </v-card-title>
      <v-card-text>
        <div
          v-for="(organization, index) in organizations"
          :key="`organization-${index}`"
        >
          <p class="text-padding" v-if="organization.id == $route.params.id">
            <template v-if="organization.logo_url != ''">
              <v-img
                height="200"
                width="200"
                :src="organization.logo_url"
              ></v-img>
            </template>
            <template v-else>
              <v-img
                height="150"
                width="150"
                :src="'/img/camera-off.png'"
              ></v-img>
            </template>
          </p>
        </div>

        <div
          class="text-padding"
          v-for="videogame in videogames"
          :key="videogame.id"
        >
          <p class="font-weight-ligth" v-if="videogame.id == gameid">
            Juego: {{ videogame.name }}
          </p>
        </div>
        <div
          class="text-padding"
          v-for="(ability, index) in abilities"
          :key="`ability-${index}`"
        >
          <p v-if="ability.id == $route.params.ability_id">
            Habilidad: {{ ability.name }}
          </p>
        </div>
        <div class="text-padding">
          <p class="font-weight-medium" aria-label="tabla métricas">
            Este reporte muestra informacion de los aciertos omisiones y fallos
            por sesion
          </p>
        </div>

        <v-data-table
          :style="{ 'background-color': color }"
          dark
          :headers="headers"
          :items="sessions"
          :items-per-page="5"
          :footer-props="{
            'items-per-page-all-text': 'Todos',
            'items-per-page-text': 'Registros por página',
            'items-per-page-options': [5, 10, -1],
            'show-current-page': true,
            pagination: {},
          }"
          no-results-text="No se encuentran resultados"
          no-data-text="No hay datos ingresados"
        >
          <template v-slot:item.date="{ item }">
            <div>{{ dateFormat(item.date) }}</div>
          </template>
          <template v-slot:item.id="{ item }">
            <div v-for="(session, index) in sessions" :key="index">
              <div v-if="session.id === item.id">{{ index + 1 }}</div>
            </div>
          </template>
          <template v-slot:item.time_played="{ item }">
            <div>{{ item.time_played }} min</div>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <v-row class="pt-5">
      <v-col cols="4" sm="5" md="5"></v-col>
      <v-col cols="4" sm="3" md="3">
        <v-btn
          aria-label="Botón imprimir"
          @click="download"
          :color="icon_color"
          dark
          depressed
          class="text-center text-capitalize body-1"
          >Imprimir</v-btn
        >
      </v-col>
      <v-col cols="4" sm="4" md="4"></v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import deleteMixin from '../../mixins/deletemixin'
import jsPDF from 'jspdf'
import 'jspdf-autotable'

export default {
  mixins: [deleteMixin],
  created() {
    this.$store.commit('layout/SET_LAYOUT', 'tutor-layout')
    this.$store.dispatch('session/fetchSessions', this.$route.params.id_iplan)
    this.$store.dispatch('interventionplan/fetchInterventionPlans', {
      id: this.$route.params.id,
      player_id: this.$route.params.player_id,
    })
    this.$store.dispatch('videogame/fetchVideogames')
    this.$store.dispatch('ability/fetchAbilities', this.$route.params.id)
    this.$store.dispatch('organization/fetchOrganizations')
  },
  computed: {
    ...mapState({
      color: (state) => state.layout.color,
      link: (state) => state.layout.primary,
      icon_color: (state) => state.layout.icon_color,
      tooltip_color: (state) => state.layout.tooltip_color,
      sessions: (state) => state.session.sessions,
      videogames: (state) => state.videogame.videogames,
      abilities: (state) => state.ability.abilities,
      organizations: (state) => state.organization.organizations,
      interventionplan: (state) => state.interventionplan.intervention_plans,
    }),
  },
  data() {
    return {
      base64: 'sss',
      gameid: this.$route.params.game_name,
      dialog: false,
      disabled: false,
      headers: [
        {
          text: 'SESIÓN',
          align: 'left',
          value: 'id',
          sortable: false,
        },
        { text: 'FECHA (MM/DD/AA)', value: 'date', sortable: false },
        {
          text: 'ACIERTOS',
          value: 'success',
          sortable: false,
        },
        {
          text: 'OMISIONES',
          value: 'omissions',
          sortable: false,
        },
        {
          text: 'FALLOS',
          value: 'failures',
          sortable: false,
        },
        {
          text: 'TIEMPO',
          value: 'time_played',
          sortable: false,
        },
        {
          text: 'OBSERVACION',
          value: 'observation',
          sortable: false,
        },
      ],
      errorIMG:
        'data:image/jpeg;base64,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',
    }
  },
  methods: {
    async download() {
      var videogame_name = ''
      var ability_name = ''
      var plan_code = ''
      var doc = new jsPDF('p', 'mm', 'a4')

      //HEAD
      doc.setDrawColor(0)
      doc.setFillColor(25, 118, 210)
      doc.rect(0, 0, 600, 50, 'F')
      doc.setFontSize(24)
      doc.setFont('Helvetica', 'bold')
      doc.setTextColor(255)

      //Texto centrado
      var title = ' Reporte de Sesiones'
      var xOffset =
        doc.internal.pageSize.width / 2 - doc.getStringUnitWidth(title) * 4
      doc.text(' Reporte de Sesiones', xOffset, 20)
      //Calculo texto centrado
      doc.setFontSize(18)
      doc.setFont('Helvetica', 'normal')
      doc.setTextColor(255)
      var text = this.$route.params.name + ' ' + this.$route.params.surname
      xOffset =
        doc.internal.pageSize.width / 2 - doc.getStringUnitWidth(text) * 3
      doc.text(
        this.$route.params.name + ' ' + this.$route.params.surname,
        xOffset,
        30
      )
      //obtencion de imagen
      for (var i = 0; i < this.interventionplan.length; i++) {
        if (this.interventionplan[i].id == this.$route.params.id_iplan) {
          plan_code = this.interventionplan[i].code
        }
      }
      doc.text(plan_code, 100, 22)
      var logo
      for (i = 0; i < this.organizations.length; i++) {
        if (this.organizations[i].id == this.$route.params.id) {
          logo = this.organizations[i].logo_url
        }
      }
      //Verificación de imagen
      var logoURI
      if (logo != '') {
        logoURI = await this.getDataUri(logo)
      } else {
        logoURI = this.errorIMG
      }

      doc.addImage(logoURI, 'JPEG', 15, 31, 33, 33)
      doc.setTextColor(0)
      doc.setFontSize(12)
      for (i = 0; i < this.videogames.length; i++) {
        if (this.videogames[i].id == this.$route.params.game_name) {
          videogame_name = this.videogames[i].name
        }
      }
      for (var j = 0; j < this.abilities.length; j++) {
        if (this.abilities[j].id == this.$route.params.ability_id) {
          ability_name = this.abilities[j].name
        }
      }
      //BODY
      doc.setFontSize(12)
      doc.setFont('Helvetica', 'normal')
      doc.text('Juego: ' + videogame_name, 15, 80)
      doc.text('Habilidad: ' + ability_name, 15, 90)

      doc.setFontSize(11)
      doc.text(
        'Este reporte muestra información de los aciertos, omisiones y fallos por sesión.',
        15,
        100
      )
      //var columnsBody = ["No.", "Fecha", "Progreso", "Accion", "Observacion"];
      var headers = [
        { title: 'Sesión', datakey: 'session' },
        { title: 'Fecha (MM/DD/AA)', datakey: 'date' },
        { title: 'Aciertos', datakey: 'success' },
        { title: 'Omisiones', datakey: 'omissions' },
        { title: 'Fallos', datakey: 'failures' },
        { title: 'Tiempo', datakey: 'time_played' },
        { title: 'Observación', datakey: 'observation' },
      ]
      //eslint-disable-next-line
      console.log(this.sessions)
      var body = []
      for (i = 0; i < this.sessions.length; i++) {
        var date = this.dateFormat(this.sessions[i].date)
        var time = this.sessions[i].time_played + ' min'
        var temp = [
          i + 1,
          date,
          this.sessions[i].success,
          this.sessions[i].omissions,
          this.sessions[i].failures,
          time,
          this.sessions[i].observation,
        ]
        body.push(temp)
      }
      doc.autoTable(headers, body, {
        theme: 'grid',
        startY: 110,
        headStyles: {
          fillColor: [107, 174, 246],
          halign: 'center',
          valign: 'middle',
          font: 'helvetica',
          fontSize: 11,
        },
        bodyStyles: {
          halign: 'center',
          valign: 'middle',
          font: 'helvetica',
          fontSize: 10,
          textColor: 20,
        },
      })
      doc.save('tabla_sesiones.pdf')
    },
    async getDataUri(url) {
      return new Promise((resolve) => {
        var image = new Image()
        image.setAttribute('crossOrigin', 'anonymous') //getting images from external domain

        image.onload = function () {
          var canvas = document.createElement('canvas')
          canvas.width = this.naturalWidth
          canvas.height = this.naturalHeight

          //next three lines for white background in case png has a transparent background
          var ctx = canvas.getContext('2d')
          ctx.fillStyle = '#fff' /// set white fill style
          ctx.fillRect(0, 0, canvas.width, canvas.height)

          canvas.getContext('2d').drawImage(this, 0, 0)

          resolve(canvas.toDataURL('image/jpeg'))
        }

        image.src = url
      })
    },
    dateFormat(date) {
      var year = date.slice(0, 4)
      var day = date.slice(8, 10)
      var month = date.slice(5, 7)

      return day + '/' + month + '/' + year
    },
  },
}
</script>
<style scoped>
.text-padding {
  padding-left: 10px;
  padding-bottom: 0px;
  font-size: medium;
  color: whitesmoke;
}
</style>
